import "magnific-popup";
import "owl.carousel";

jQuery( document ).ready(function($) {
    $(document).on('mousemove', function(e) {
        $('#custom-cursor').css({
            left: e.clientX + 'px',
            top: e.clientY + 'px'
        });  
    });

    $('iframe').on('mouseenter', function() {
        $('#custom-cursor').hide();
    });

    $('iframe').on('mouseleave', function() {
        $('#custom-cursor').show();
    });

    $('.section').hide();

    $('.home-btn').on('click', function(e){
        $('.section').fadeOut();
        $('body').removeClass();
        $('body').addClass('home');
        $('#home').show();
    })

    $('#home .float').on('click', function(e){
        e.preventDefault();
        let target = $(this).attr('data-target');
        let targetdiv = '#' + target;
        $('#home').fadeOut(function(){
            $('body').removeClass();
            $('body').addClass(target);
            $(targetdiv).fadeIn();
        })
    })

    $('#main').magnificPopup({
        delegate: '.photo-item',
        type: 'image'
    })

    $('.owl-carousel').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        navText: ['<span>‹</span><span class="sr-only">previous</span>','<span >›</span><span class="sr-only">next</span>'],
        responsive:{
            0:{
                items:2
            },
            700:{
                items:3
            }
        }
    })
}); 